import React, { useRef, useEffect, useState } from 'react';
import EZUIKit from 'ezuikit-js';
import { Input, Button, Card, Space, Alert, message, Select } from 'antd';
import axios from 'axios';

const HlsTest = () => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('未初始化');
  const [url, setUrl] = useState('');
  const [logs, setLogs] = useState([]);

  // 表单状态
  const [appKey, setAppKey] = useState('f4c036dafa3840f3aec0ff87295da8bd');
  const [appSecret, setAppSecret] = useState('c7c088b3c1341fcd22f168bc767ed187');
  const [deviceSerial, setDeviceSerial] = useState('33011083992397173370:33011087991117888746');
  const [channelNo, setChannelNo] = useState('3');
  const [protocol, setProtocol] = useState('1');
  const [loading, setLoading] = useState(false);

  const [accessToken, setAccessToken] = useState('');

  const addLog = (msg) => {
    const time = new Date().toLocaleTimeString();
    setLogs(prev => [...prev.slice(-20), `[${time}] ${msg}`]);
  };

  const createPlayer = (videoUrl, token) => {
    // 先销毁已有播放器
    if (playerRef.current) {
      playerRef.current.stop();
      playerRef.current = null;
    }

    if (!videoUrl) {
      setError('请输入播放地址');
      return;
    }

    // 清空容器
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    setError(null);
    setStatus('创建播放器...');
    addLog('开始加载: ' + videoUrl);

    try {
      playerRef.current = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: 'ezuikit-player',
        accessToken: token,
        url: videoUrl,
        template: 'standard', // simple-极简版 | standard-标准版 | security-安防版
        width: '100%',
        height: '450px',
      });

      setStatus('播放器已创建');
      addLog('播放器实例已创建');
    } catch (err) {
      addLog('创建失败: ' + err.message);
      setError(err.message);
      setStatus('创建失败');
      console.error('创建播放器失败:', err);
    }
  };

  // 通过 API 获取播放地址
  const handleGetAddress = async () => {
    if (!appKey || !appSecret || !deviceSerial) {
      setError('请填写完整信息');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      setStatus('获取 AccessToken...');
      addLog('1. 获取 AccessToken...');

      // 通过后端 API 获取，解决 CORS 问题
      const res = await axios.post('/api/trace/ys7-live-address', {
        companyId: 1,
        appKey,
        appSecret,
        deviceSerial,
        channelNo: channelNo || 1,
        protocol: parseInt(protocol)
      });

      console.log('API 响应:', res.data);
      addLog('API 响应: ' + JSON.stringify(res.data));

      if (res.data.code != 200) {
        throw new Error(res.data.msg || '获取地址失败');
      }

      const playUrl = res.data.data.url;
      const token = res.data.data.accessToken;

      addLog('获取地址成功: ' + playUrl);
      setUrl(playUrl);
      setAccessToken(token);
      message.success('获取播放地址成功');

      // 自动播放
      setTimeout(() => createPlayer(playUrl, token), 100);

    } catch (err) {
      console.error('完整错误:', err);

      let errMsg = '';
      if (err.response) {
        errMsg = err.response.data?.msg || err.response.statusText || JSON.stringify(err.response.data);
      } else if (err.request) {
        errMsg = '网络错误: ' + err.message;
      } else {
        errMsg = err.message;
      }

      addLog('错误: ' + errMsg);
      setError(errMsg);
      setStatus('获取失败');
    } finally {
      setLoading(false);
    }
  };

  const handlePlay = () => {
    if (accessToken && url) {
      createPlayer(url, accessToken);
    } else {
      setError('请先获取播放地址');
    }
  };

  useEffect(() => {
    return () => {
      if (playerRef.current) {
        playerRef.current.stop();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      <h1>萤石云播放器测试 (ezuikit-js)</h1>

      <Card title="通过 API 获取播放地址" style={{ marginBottom: '20px' }}>
        <Space wrap style={{ marginBottom: '10px' }}>
          <div>
            <div style={{ marginBottom: '4px' }}>AppKey</div>
            <Input
              value={appKey}
              onChange={e => setAppKey(e.target.value)}
              style={{ width: 250 }}
            />
          </div>
          <div>
            <div style={{ marginBottom: '4px' }}>AppSecret</div>
            <Input.Password
              value={appSecret}
              onChange={e => setAppSecret(e.target.value)}
              style={{ width: 280 }}
            />
          </div>
          <div>
            <div style={{ marginBottom: '4px' }}>设备序列号</div>
            <Input
              value={deviceSerial}
              onChange={e => setDeviceSerial(e.target.value)}
              style={{ width: 280 }}
            />
          </div>
          <div>
            <div style={{ marginBottom: '4px' }}>通道号</div>
            <Input
              value={channelNo}
              onChange={e => setChannelNo(e.target.value)}
              style={{ width: 80 }}
            />
          </div>
          <div>
            <div style={{ marginBottom: '4px' }}>协议</div>
            <Select
              value={protocol}
              onChange={setProtocol}
              style={{ width: 100 }}
            >
              <Select.Option value="1">EZOPEN</Select.Option>
              <Select.Option value="2">RTMP</Select.Option>
              <Select.Option value="3">HLS</Select.Option>
              <Select.Option value="4">FLV</Select.Option>
            </Select>
          </div>
          <div style={{ alignSelf: 'flex-end' }}>
            <Button
              type="primary"
              onClick={handleGetAddress}
              loading={loading}
            >
              获取地址并播放
            </Button>
          </div>
        </Space>
      </Card>

      <Card style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Input
            placeholder="播放地址 (ezopen://...)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            style={{ flex: 1 }}
          />
          <Button type="primary" onClick={handlePlay}>
            播放
          </Button>
        </div>
      </Card>

      <div style={{ marginBottom: '20px' }}>
        <p><strong>状态:</strong> {status}</p>
        {error && <Alert type="error" message={error} style={{ marginBottom: 10 }} />}
      </div>

      <div
        id="ezuikit-player"
        ref={containerRef}
        style={{
          width: '100%',
          maxWidth: '800px',
          height: '450px',
          backgroundColor: '#000',
          marginBottom: '20px'
        }}
      />

      <Card title="播放日志" size="small">
        <div style={{
          fontFamily: 'monospace',
          fontSize: '12px',
          maxHeight: '200px',
          overflow: 'auto',
          background: '#f5f5f5',
          padding: '10px',
          whiteSpace: 'pre-wrap'
        }}>
          {logs.length === 0 ? '暂无日志' : logs.join('\n')}
        </div>
      </Card>
    </div>
  );
};

export default HlsTest;
